import React from 'react';
import { Info } from 'lucide-react';
import { ESTIMATE_DISCLAIMER_TEXT, ESTIMATE_DISCLAIMER_SHORT } from '../constants/estimateDisclaimer';

interface EstimateDisclaimerProps {
  variant?: 'block' | 'inline';
  className?: string;
}

const EstimateDisclaimer: React.FC<EstimateDisclaimerProps> = ({ variant = 'block', className = '' }) => {
  if (variant === 'inline') {
    return (
      <span
        className={`inline-flex items-center gap-1 text-[10px] italic text-gray-500 ${className}`}
        title={ESTIMATE_DISCLAIMER_TEXT}
      >
        <Info className="w-3 h-3" />
        {ESTIMATE_DISCLAIMER_SHORT}
      </span>
    );
  }
  return (
    <div className={`flex items-start gap-1.5 text-xs italic text-gray-500 ${className}`}>
      <Info className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
      <span>{ESTIMATE_DISCLAIMER_TEXT}</span>
    </div>
  );
};

export default EstimateDisclaimer;
